<template>
    <VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div" class="col-12">
        <form class="postcode-form" @submit="handleSubmit($event, $emit('submit'))" method="post" :action="this.baseUrl + '/rechoose-fitters'">
            <div class="d-flex flex-column flex-md-row gap-3 mb-3">
                <div class="">
                    <b class="d-inline-block mb-2">Showing local fitters in the area of</b>
                    <div class="d-flex gap-3">
                        <div class="" style="flex-basis: 100%">
                            <Field id="postcode" name="postcode" type="text" class="form-control postcode uppercase" :value="filters.postcode" @input="updateFilters('postcode', $event.target.value)" placeholder="Postcode" :class="{'error': errors.postcode}"/>
                            <div class="error-msg">{{ errors.postcode }}</div>
                        </div>
                        <div class="" style="flex-basis: 100%">
                            <Field name="distance" as="select" class="form-select cursor-pointer" id="distance-input" :value="filters.distance" @input="updateFilters('distance', parseInt($event.target.value))">
                                <option v-for="mile, key in [5, 10, 15, 25, 50]" :value="mile" :key="key">{{ mile }} Miles</option>
                            </Field>
                        </div>
                        <div class="">
                            <button type="submit" class="btn btn-sm btn-primary px-3">
                                Go
                            </button>
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-column flex-sm-row align-items-center">
                    <div class="d-block text-start me-auto me-3 mb-2 mb-sm-0">
                        <b class="d-block mb-2">Sort fitters by:</b>
                        <div class="position-relative">
                            <Field name="sort_by" as="select" class="form-select cursor-pointer" id="sortby-input" :class="filters.sortBy" :value="filters.sortBy" @input="updateFilters('sortBy', $event.target.value)">
                                <option value="distance" :selected="filters.sortBy != null && filters.sortBy == 'distance'">Nearest first</option>
                                <option value="earliest_fitting_date" :selected="filters.sortBy != null && filters.sortBy == 'earliest_fitting_date'">Earliest fitting date</option>
                                <option v-if="hasReviews" value="average_score" :selected="filters.sortBy != null && filters.sortBy == 'average_score'">Best rating</option>
                            </Field>
                        </div>
                    </div>
                    <div class="w-xs-100">
                        <b class="d-block mb-2 ms-sm-3">Fitter type:</b>
                        <div class="d-flex flex-column flex-sm-row gap-3">
                            <div class="d-flex align-items-baseline gap-3">
                                <div class="d-flex" v-for="(type, key) of fitterTypes" :key="key">
                                    <input name="fitter_types[]" type="checkbox" class="btn-check" :id="type" :checked="typeIsIncluded(type)" @input="updateFitterTypes(type, $event.target.checked)" autocomplete="off">
                                    <label class="form-control filter-border capitalize btn cursor-pointer d-flex align-items-center gap-2 p-2" :class="[typeIsIncluded(type) ? 'active' : 'in-active', type == 'garage' ? 'ms-sm-3' : '']" :for="type" :key="key">
                                        <i class="text-primary" :class="typeIsIncluded(type) ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'"></i>
                                        <span class="text-black">{{ type }} fitter</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </VeeForm>
</template>

<script>
    import { Form as VeeForm, Field , ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
    
    export default {
        props:  ['filters', 'hasReviews', 'page', 'fittersShown', 'postcode'],
        components: {
            VeeForm,
            Field,
            ErrorMessage
        },
        data() {
            const postcodeValidationSchema = yup.object({
                'postcode': yup.string().required('Postcode is required')
            });

            return {
                fitterTypes: ['garage', 'mobile'],
                postcodeValidationSchema,
                selectedFitterTypes: []
            }
        },
        created() {
            
        },
        mounted() {
        },
        methods: {
            typeIsIncluded(type) {
                return this.filters.fitterTypes.includes(type);
            },
            updateFitterTypes(type, checked) {
                // Clone fitter types so we don't edit the original prop
                let fitterTypes = [...this.filters.fitterTypes];

                // Check if type is already present in fitter types
                const index = fitterTypes.indexOf(type);

                if (checked && index === -1) fitterTypes.push(type);

                if (!checked && index > -1) fitterTypes.splice(index, 1);

                this.updateFilters('fitterTypes', fitterTypes);
            },
            updateFilters(key, value) {
                this.$emit('update-filters', {
                    key: key,
                    value: value
                });
            },
            onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .custom-select {
        width: 155px;
    }
    .btn-grey {
        color: #141414;
        background-color: #D3D3D3;
        cursor: pointer;
    }
    .filter-border {
        border: 1px solid #767676 !important;
    }
</style>